import { makeAutoObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { EmployeeStore } from './EmployeeStore';

class RootStore {
  employeeStore: EmployeeStore;

  constructor() {
    this.employeeStore = new EmployeeStore();
    makeAutoObservable(this);
  }

  // Здесь будут добавлены другие stores
}

export const rootStore = new RootStore();
export const RootStoreContext = createContext(rootStore);
export const useRootStore = () => useContext(RootStoreContext);
